var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full pl-2 pr-2"},[_c('p',{staticClass:"mb-2 text-sm"},[_vm._v("\n        カード裏面のご署名欄に印字された数字の末尾3桁"),_c('br'),_vm._v("\n        (AMEXカードの場合はカード表面の4桁)\n    ")]),_vm._v(" "),_c('img',{staticClass:"w-80 max-w-full",attrs:{"src":"/images/security_code.png","alt":"セキュリティコード"}})])
}]

export { render, staticRenderFns }